import { Component, OnInit } from '@angular/core';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { TrajectoryService } from 'src/app/services/trajectory.service';

@Component({
  selector: 'app-trajetcory',
  templateUrl: './trajetcory.component.html',
  styleUrls: ['./trajetcory.component.scss'],
  standalone: false
})
export class TrajetcoryComponent implements OnInit {

  constructor(public trajectoryService: TrajectoryService,
    public menuController : MenuManagementService,
    private toolsService : ToolsControlService
    ) { }

  ngOnInit(): void {
  }

  cancelTrajectories():void{
    this.toolsService.navigationOnTop = false;
    this.trajectoryService.active = !this.trajectoryService.active;
  }

}
